import { useReducer } from 'react';
import { NewOffsiteCampaignReducer } from './NewOffsiteCampaignReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  NewOffsiteCampaignDispatchContext,
  NewOffsiteCampaignStateContext,
} from './UseNewOffsiteCampaignContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface INewOffsiteCampaignProviderProps {
  children: any;
  value?: IValue;
}

export function NewOffsiteCampaignProvider({
  children,
  value = { initialState: defaultContextValues, reducer: NewOffsiteCampaignReducer },
}: INewOffsiteCampaignProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <NewOffsiteCampaignStateContext.Provider value={state}>
      <NewOffsiteCampaignDispatchContext.Provider value={dispatch}>
        {children}
      </NewOffsiteCampaignDispatchContext.Provider>
    </NewOffsiteCampaignStateContext.Provider>
  );
}
